import {
    GETALLOPTICOPDITEMQTY,
    GETSETUPOPTICSHOPUNIT,
    CREATESETUPOPTICSHOPUNIT,
    UPDATESETUPOPTICSHOPUNIT,
    DELETESETUPOPTICSHOPUNIT,
    GETSETUPOPTICSHOPSUPPLIER,
    CREATESETUPOPTICSHOPSUPPLIER,
    UPDATESETUPOPTICSHOPSUPPLIER,
    DELETESETUPOPTICSHOPSUPPLIER,
    GETSETUPOPTICSHOPITEMCATEGORY,
    CREATESETUPOPTICSHOPITEMCATEGORY,
    UPDATESETUPOPTICSHOPITEMCATEGORY,
    DELETESETUPOPTICSHOPITEMCATEGORY,
    GETSETUPOPTICSHOPITEMS,
    CREATESETUPOPTICSHOPITEMS,
    UPDATESETUPOPTICSHOPITEMS,
    DELETESETUPOPTICSHOPITEMS,
} from "../actions/types"

const initialState = {
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GETSETUPOPTICSHOPUNIT:
            return {
                ...state,
                SetupOpticShopUnitList: action.payload.data,
            };
        case GETALLOPTICOPDITEMQTY:
            return {
                ...state,
                SetupOpticShopItemQtyList: action.payload.data,
            };
        case CREATESETUPOPTICSHOPUNIT:
            return {
                ...state,
                SetupOpticShopUnitSaveStatus: action.payload.success,
            }
        case UPDATESETUPOPTICSHOPUNIT:
            return {
                ...state,
                SetupOpticShopUnitUpdateStatus: action.payload.success,
            };

        case DELETESETUPOPTICSHOPUNIT:
            return {
                ...state,
                SetupOpticShopUnitDeleteStatus: action.payload.success,
            };
        case GETSETUPOPTICSHOPSUPPLIER:
            return {
                ...state,
                SetupOpticShopSupplierList: action.payload.data,
            };
        case CREATESETUPOPTICSHOPSUPPLIER:
            return {
                ...state,
                SetupOpticShopSupplierSaveStatus: action.payload.success,
            }
        case UPDATESETUPOPTICSHOPSUPPLIER:
            return {
                ...state,
                SetupOpticShopSupplierUpdateStatus: action.payload.success,
            };

        case DELETESETUPOPTICSHOPSUPPLIER:
            return {
                ...state,
                SetupOpticShopSupplierDeleteStatus: action.payload.success,
            };
        case GETSETUPOPTICSHOPITEMCATEGORY:
            return {
                ...state,
                SetupOpticShopItemCategoryList: action.payload.data,
            };
        case CREATESETUPOPTICSHOPITEMCATEGORY:
            return {
                ...state,
                SetupOpticShopItemCategorySaveStatus: action.payload.success,
            }
        case UPDATESETUPOPTICSHOPITEMCATEGORY:
            return {
                ...state,
                SetupOpticShopItemCategoryUpdateStatus: action.payload.success,
            };

        case DELETESETUPOPTICSHOPITEMCATEGORY:
            return {
                ...state,
                SetupOpticShopItemCategoryDeleteStatus: action.payload.success,
            };
        case GETSETUPOPTICSHOPITEMS:
            return {
                ...state,
                SetupOpticShopItemsList: action.payload.data,
            };
        case CREATESETUPOPTICSHOPITEMS:
            return {
                ...state,
                SetupOpticShopItemsSaveStatus: action.payload.success,
            }
        case UPDATESETUPOPTICSHOPITEMS:
            return {
                ...state,
                SetupOpticShopItemsUpdateStatus: action.payload.success,
            };

        case DELETESETUPOPTICSHOPITEMS:
            return {
                ...state,
                SetupOpticShopItemsDeleteStatus: action.payload.success,
            };

        default:
            return state;
    }
}